const Dashboard = () => import("../organization/dashboard/views/Dashboard.vue");
import BranchRoutes from "../organization/branch/routes";
import DepartmentRoutes from "../organization/department/routes";
import TeamRoutes from "../organization/team/routes";
import EmployeeRoutes from "../organization/employee/routes";
import ReportRoutes from "../organization/reports/routes";
import SettingsRoutes from "../organization/settings/routes";
export default [
  {
    path: "dashboard",
    component: Dashboard,
  },
  {
    path: "branch",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    redirect: "/admin/organization/branch/view-all",
    children: BranchRoutes,
  },
  {
    path: "department",
    name: "organization-department",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    redirect: "/admin/organization/department/view-all",
    children: DepartmentRoutes,
  },
  {
    path: "team",
    name: "organization-team",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    redirect: "/admin/organization/team/view-all",
    children: TeamRoutes,
  },
  {
    path: "employees",
    name: "organization-employees",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    redirect: "/admin/organization/employees/view-all",
    children: EmployeeRoutes,
  },
  {
    path: "reports",
    name: "organization-reports",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    redirect: "/admin/organization/reports/generate",
    children: ReportRoutes,
  },
  {
    path: "system-settings",
    name: "organization-system-settings",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: SettingsRoutes,
  },
];
